<h4>MIS DATOS</h4>
<label class>Elegir productos a los cuales desea modificar datos:</label>

<div class="container-select">
  <app-form-select
    [(ngModel)]="selectedProd"
    [label]="'Tipo de cuenta'"
    ($onChange)="onProdChange($event.value)"
    class="input-tipo-cuenta"
    [options]="productos"
    [optionDescription]="'Nombre'"
  ></app-form-select>
</div>
<app-card-datos-contratante-producto
  *ngIf="lineaProd == 'INDIVIDUAL'"
  [idPoliza]="selectedProd.Poliza"
  [lineaNegocio]="'INDIVIDUAL'"
>
</app-card-datos-contratante-producto>
<app-card-asegurado
  *ngIf="lineaProd == 'COLECTIVO'"
  [idPoliza]="selectedProd.Poliza"
  [lineaNegocio]="lineaProd"
></app-card-asegurado>
